// src/hooks/useNotifications.ts
import { useState, useCallback } from 'react';
import { NotificationState } from '../types';

export const useNotifications = () => {
  const [notification, setNotification] = useState<NotificationState>({
    open: false,
    message: '',
    severity: 'info'
  });

  const showNotification = useCallback((
    message: string, 
    severity: NotificationState['severity'] = 'info'
  ) => {
    setNotification({ 
      open: true, 
      message, 
      severity 
    });
  }, []);

  const hideNotification = useCallback(() => {
    setNotification(prev => ({ 
      ...prev, 
      open: false 
    }));
  }, []);

  // Convenience methods for common notification types
  const showSuccess = useCallback((message: string) => {
    showNotification(message, 'success');
  }, [showNotification]);

  const showError = useCallback((message: string) => {
    showNotification(message, 'error');
  }, [showNotification]);

  const showWarning = useCallback((message: string) => {
    showNotification(message, 'warning');
  }, [showNotification]);

  const showInfo = useCallback((message: string) => {
    showNotification(message, 'info');
  }, [showNotification]);

  return {
    notification,
    showNotification,
    hideNotification,
    showSuccess,
    showError,
    showWarning,
    showInfo,
  };
};